<template>
  <div class="AddCase">
    <div class="titlePage">{{ this.titleCase }}</div>
    <modal
      name="CaseModalUpdate"
      width="50%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      style="overflow: scroll"
    >
      <div class="infoForm">
        <va-notification
          color="info"
          class="refNoData"
          v-html="'Se ingreso correctamente la encuesta.'"
        />
        <div class="text-right">
          <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="lodnewCase">
            Cerrar
          </button>
        </div>
      </div>
    </modal>
    <va-notification
      color="danger"
      v-if="refdataResum"
      class="refNoData"
      v-html="'Ha superado el límite de casos permitidos.'"
    />
    <va-notification
      color="danger"
      v-if="refNoCase"
      class="refNoData"
      v-html="
        'No se encuentran intersemestrales activos para ' +
        this.tempData.FacultyName +
        '.'
      "
    />
    <va-notification
      color="danger"
      v-if="refNoProgram"
      class="refNoData"
      v-html="
        'No se encuentran cursos activos para el programa ' +
        this.tempData.ProgramName +
        '.'
      "
    />
    <va-notification
      color="info"
      v-if="addRExito"
      class="refNoData"
      v-html="'Se creo correctamente el caso solicitado.'"
    />
    <va-notification
      color="danger"
      v-if="addRFail"
      class="refNoData"
      v-html="'No se creo correctamente el caso solicitado.'"
    />
    <va-notification
      color="danger"
      v-if="noStudent"
      class="refNoData"
      v-html="
        'El usuario ' +
        this.CaseRef.NamPerson +
        ' ' +
        this.CaseRef.LastNamePerson +
        ', no está registrado en ningún programa de la Universidad Iberoamericana.'
      "
    />
    <!-- <div class="flex xs12" v-if="totaldata"> -->
    <div class="flex xs12" v-if="totaldata,totaldataNoForm, totaldataResum">
      <va-card>
        <ValidationObserver ref="obsFieldsUpdate">
          <table class="table">
            <tbody>
              <tr>
                <td class="titleData">Detalle</td>
                <td>{{ this.CaseRef.CasePerson[0].Det_Subject }}</td>
                <th class="titleData" scope="row">Tipo de Caso</th>
                <td>{{ this.CaseRef.CasePerson[0].Det_CaseType }}</td>
              </tr>
              <tr>
                <th class="titleData" scope="row">Número de Caso</th>
                <td>{{ this.CaseRef.CasePerson[0].Det_Reason }}</td>
                <!-- <td class="titleData">Fecha de Creación</td>
                <td>{{ this.CaseRef.CasePerson[0].Modified_Time }}</td> -->
              </tr>
              <tr>
                <th class="titleData" scope="row">Nombres</th>
                <td>{{ this.CaseRef.NamPerson }}</td>
                <td class="titleData">Apellidos</td>
                <td>{{ this.CaseRef.LastNamePerson }}</td>
              </tr>
              <tr>
                <th class="titleData" scope="row">Tipo de Documento</th>
                <td>{{ this.CaseRef.NameDocument }}</td>
                <td class="titleData">Numero de Documento</td>
                <td>{{ this.CaseRef.NumDocument }}</td>
              </tr>
              <tr>
                <th class="titleData" scope="row">ID Banner</th>
                <td>{{ this.CaseRef.IdBanner }}</td>
                <th class="titleData" scope="row">Correo Institucional</th>
                <td>{{ this.CaseRef.EmailCorporative }}</td>
              </tr>
              <tr>
                <td class="titleData alterData">Correo Personal</td>
                <td class="alterData" v-if="this.tempData.detMail">
                  {{ this.tempData.detMail }}
                </td>
                <td class="alterData" v-else>
                  <ValidationProvider
                    :class="{ classes: true }"
                    name="Correo Personal"
                    rules="required|email"
                    v-slot="{ classes, errors }"
                  >
                    <input
                      v-model="formUpdModel['RefMail']"
                      placeholder="Correo Personal"
                      maxlength="100"
                      :class="classes"
                      class="form-control col-md-12"
                    />
                    <div class="is-invalid-form">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
                <td class="titleData alterData">Celular</td>
                <td class="alterData" v-if="this.tempData.detCelular">
                  {{ this.tempData.detCelular }}
                </td>
                <td class="alterData" v-else>
                  <ValidationProvider
                    :class="{ classes: true }"
                    name="Celular"
                    rules="required|numeric|min:10"
                    v-slot="{ classes, errors }"
                  >
                    <input
                      v-model="formUpdModel['RefCelPhone']"
                      placeholder="Celular"
                      maxlength="10"
                      :class="classes"
                      class="form-control col-md-12"
                    />
                    <div class="is-invalid-form">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </ValidationObserver>
      </va-card>
    </div>
    <div v-if="totaldata" />
    <va-notification
      color="warning"
      v-if="totaldata"
      class="noteCaseTxt"
      v-html="this.tempData.CaseNote"
    />
    <div class="Separador"></div>
    <div class="titlePage" v-if="totaldataFacul">
      {{ this.tempData.FacultyName }}
    </div>
    <div class="flex xs12" v-if="totaldataFacul">

      <va-card>
        <va-accordion>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active" aria-current="page">
                {{ this.tempData.ProgramName }}
              </li>
            </ol>
          </nav>
          <div class="row interData">
            <template v-for="itemProList of this.tempData.CaseCourses">
              <div
                :key="itemProList.CaseIDByCourse"
                class="custom-control custom-checkbox col-md-6"
              >
                <input
                  v-model="modelArray[itemProList.CaseIDByCourse]"
                  type="checkbox"
                  class="custom-control-input"
                  :id="itemProList.CaseIDByCourse"
                />
                <label
                  class="custom-control-label"
                  :for="itemProList.CaseIDByCourse"
                  >{{ itemProList.CaseCourseName }}</label
                >
              </div>
            </template>
          </div>
        </va-accordion>
        <div v-if="alertCourse" class="is-invalid-form alertCourse">
          * Debe seleccionar mínimo un curso para poder generar el caso.
        </div>
        <div class="text-right">
          <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="this.validateCase">
            <va-icon name="fa fa-database" size="60" /> Generar Caso
          </button>
        </div>
      </va-card>
    </div>
    <div class="flex xs12" v-if="totaldataForm">
      <va-notification color="warning" class="refNoData"
        >En este momento no se encuentran casos activos asignados a su
        cuenta.</va-notification
      >
    </div>
    <div class="flex xs12" v-if="totaldataForm"> <!-- <div class="flex xs12" v-if="totaldataForm,totaldataNoForm"> -->
      <va-card>
        <ValidationObserver ref="obsFieldsCase">
          <FormCaseSelect
            :FieldsForm="formCase"
            :ModelForm="formCaseModel"
            :method="executeProcess"
          />
        </ValidationObserver>
        <div class="text-right">
          <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="sendCase">
            <va-icon name="fa fa-database" size="60" /> Enviar
          </button>
        </div>
      </va-card>
    </div>
    <div class="Separador"></div>
    <div class="titlePage" v-if="totaldataResum"> <!-- <div class="titlePage" v-if="totaldataResum,totaldataNoForm"> -->
      Listado de Casos - {{ this.CaseRef.NamPerson }}
      {{ this.CaseRef.LastNamePerson }}
    </div>
    <div class="flex xs12" v-if="totaldataResum"> <!-- <div class="flex xs12" v-if="totaldataResum,totaldataNoForm"> -->

      <va-card>
        <va-accordion>
          <div class="row interDataCase">
            <div class="col-md-12">
              <dataTables
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
              />
            </div>
          </div>
        </va-accordion>
      </va-card>
    </div>
  </div>
</template>

<script>
import ListHistory from '@/components/data-tables/DataHistory.vue'
import dataTables from '@/components/data-tables/DataListCase.vue'
import FormCaseSelect from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'AddCase',
  data () {
    return {
      titleCase: '',
      addRFail: false,
      alertCourse: false,
      totaldata: false,
      totaldataFacul: false,
      totaldataForm: false,
      totaldataNoForm: false,
      formUpdModel: {
        RefMail: '',
        RefCelPhone: '',
      },
      HDDataList: [
        {
          name: 'Id_CasePerson',
          title: 'Caso',
          width: '10%',
        },
        {
          name: 'Det_Subject',
          title: 'Detalle',
          width: '50%',
        },
        {
          name: 'Det_CaseType',
          title: 'Tipo de Caso',
          width: '20%',
        },
        {
          name: '__slot:courseList',
          title: 'Cursos Solicitados',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:dateCreted',
          title: 'Fecha Creacion',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:statusCases',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
      ],
      DLDataList: [],
      CaseRef: [],
      modelArray: {},
      courseArray: {},
      tempData: {},
      courseList: [],
      refNoProgram: false,
      totaldataResum: false,
      refdataResum: false,
      refNoCase: false,
      addRExito: false,
      noStudent: false,
      formCaseModel: {
        IdInquietud: '',
        IdNivel: '',
        IdCalidad: '',
      },
      formCase: [
        {
          id: 'IdInquietud',
          model: 'IdInquietud',
          name: '1.¿Tu inquietud ha sido resuelta?',
          type: 'radio',
          placeholder: '¿Tu inquietud ha sido resuelta?',
          values: [
            {
              id: 'Si',
              value: 'Si',
            },
            {
              id: 'No',
              value: 'No',
            },
          ],
          validate: {
            required: true,
          },
          class: 'col-md-12',
          hidden: true,
        },
        {
          id: 'IdNivel',
          model: 'IdNivel',
          name: '2.¿Qué tan fácil fue lograr la respuesta a tu caso?',
          type: 'radiostar',
          placeholder: '¿Qué tan fácil fue lograr la respuesta a tu caso?',
          values: [
            {
              id: '1',
              value: '1',
            },
            {
              id: '2',
              value: '2',
            },
            {
              id: '3',
              value: '3',
            },
            {
              id: '4',
              value: '4',
            },
            {
              id: '5',
              value: '5',
            },
          ],
          validate: {
            required: false,
          },
          class: 'col-md-6',
          hidden: true,
        },
        /* {
          id: 'IdCalidad',
          model: 'IdCalidad',
          name: '3.¿Qué tan satisfecho esta con la calidad de la información entregada?',
          type: 'Select',
          placeholder: '¿Qué tan satisfecho esta con la calidad de la información entregada?',
          values: [
            {
              id: 'Bajo (1-4)',
              value: 'Bajo (1-4)',
            },
            {
              id: 'Medio (5-7)',
              value: 'Medio (5-7)',
            },
            {
              id: 'Alto (8-10)',
              value: 'Alto (8-10)',
            },
          ],
          validate: {
            required: true,
          },
          class: 'col-md-12',
        }, */
      ],
    }
  },
  components: {
    ListHistory,
    dataTables,
    FormCaseSelect,
  },
  methods: {
    executeProcess: function (event) {
      return true
    },
    sendCase () {
      this.addRFail = false
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsCase.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var infoArray = []
            for (var i = 0; i < this.formCase.length; i++) {
              infoArray.push({
                id: this.formCase[i].model,
                detail: this.formCase[i].placeholder,
                value: this.formCaseModel[this.formCase[i].model],
              })
            }
            var InfData = {
              idCase: this.CaseRef.CasePersonForm[0].Id_CasePerson,
              idPerson: this.$session.get('IberoJWTAdminLogin').idPerson,
              detailForm: infoArray,
            }
            /* var InfData = {
              idCase: '3229357000432908738',
              idPerson: '1014218715',
              detailForm: infoArray,
            } */
            var ProcessData = IberoHelpers.updateCaseByPerson(
              this.$store,
              InfData
            )
            ProcessData.then((Response) => {
              if (Response.data) {
                this.$modal.show('CaseModalUpdate')
              } else {
                this.addRFail = true
              }
              loader.hide()
            })
            resolve(true)
          }
        })
      })
    },
    dataFindUser (array, ref) {
      var dataresult = ''
      var datResult = array.find((element) => element.idContactType === ref)
      if (datResult !== undefined) {
        dataresult = datResult.desContactInformation
      }
      return dataresult
    },
    valDate (datime) {
      return IberoHelpers.dataObjDate(datime)
    },
    lodnewCase () {
      this.$loading.show()
      location.reload()
    },
    validateCase () {
      debugger
      this.alertCourse = false
      return new Promise((resolve, reject) => {
        /* this.$refs.obsFieldsUpdate.validate().then((results) => {
          debugger;
          if (!results) {
            IberoHelpers.scrollToTop(0, 0)
            resolve(false)
          } else {
            */
        debugger
        var mateSoli = ''
        this.courseList.length = 0
        for (const items in this.modelArray) {
          if (this.modelArray[items]) {
            mateSoli += '\n- ' + this.courseArray[items]
            this.courseList.push({
              CFPC_Id: items,
              CFPC_Name: this.courseArray[items],
            })
          }
        }
        if (mateSoli === '') {
          this.alertCourse = true
        } else {
          this.tempData.detCelular = this.formUpdModel.RefCelPhone
          this.tempData.detMail = this.formUpdModel.RefMail
          this.GenerateCase(mateSoli)
        }
        resolve(true)
        // }
        // })
      })
    },
    GenerateCase (mateSoli) {
      let loader = this.$loading.show()
      this.addRExito = false
      this.addRFail = false
      var InfData = {
        idCase: this.tempData.CaseId,
        idPerson: this.CaseRef.IdPerson,
        idFaculty: this.tempData.FacultyID,
        idProgram: this.tempData.ProgramId,
        courses: this.courseList,
        caseType: this.tempData.CaseTypeName,
        mobile: this.tempData.detCelular,
        emailPersonal: this.tempData.detMail,
        emailCorporative: this.CaseRef.EmailCorporative,
        identificationNumber: this.CaseRef.NumDocument,
        bannerID: this.CaseRef.IdBanner,
        subject: this.tempData.CaseDetail,
        reason: this.tempData.CaseReason,
        status: 'Nuevo',
        priority: 'Media',
        caseOrigin: 'Pagina Web',
        message:
          'Los cursos de interés para el intersemestral del programa "' +
          this.tempData.ProgramName +
          '" son:\n' +
          mateSoli,
        zoho: '',
      }
      debugger
      var ProcessData = IberoHelpers.addCaseByPerson(this.$store, InfData)
      ProcessData.then((Response) => {
        if (Response.data) {
          this.totaldata = false
          this.totaldataFacul = false
          this.totaldataResum = false
          this.loadFacultyCase()
          this.addRExito = true
        } else {
          this.addRFail = true
        }
        loader.hide()
      })
    },
    loadCaseForm () {
      debugger
      let loader = this.$loading.show()
      var ListCase = IberoHelpers.GetCaseByUpdate(
        this.$store,
        this.$route.params.idCase,
        this.$session.get('IberoJWTAdminLogin').idPerson
      )
      debugger
      ListCase.then((Response) => {
        debugger
        this.CaseRef = Response.data.Case[0]
        /* console.log(this.CaseRef) */
        this.titleCase = this.CaseRef.CaseIbero[0].CaseDetail
        this.totaldataFacul = false

        if (!(this.CaseRef.CasePerson === undefined)) {
          this.DLDataList = this.CaseRef.CasePerson
          this.HDDataList[3].name = '__slot:detailList'
          this.HDDataList[3].title = 'Detalle Zoho'
          this.HDDataList[5].name = '__slot:detailForm'
          this.HDDataList[5].title = 'Detalle'
          this.totaldataResum = true
        } else {
          this.totaldataResum = false
        }

        if (!(this.CaseRef.CasePersonForm === undefined)) {
          this.tempData.CaseDetail = this.CaseRef.CasePersonForm[0].Det_Subject
          this.tempData.CaseTypeName =
            this.CaseRef.CasePersonForm[0].Det_CaseType
          this.tempData.CaseCourses = this.CaseRef.CaseIbero[0].CaseCourses
          this.tempData.CaseReason = this.CaseRef.CaseIbero[0].CaseReason
          this.tempData.CaseId = this.CaseRef.CaseIbero[0].CaseId
          this.tempData.CaseNote = this.CaseRef.CaseIbero[0].CaseNote
          this.tempData.detCelular = this.CaseRef.CasePersonForm[0].Det_Mobile
          this.tempData.detMail =
            this.CaseRef.CasePersonForm[0].Det_Email_Personal
          this.totaldata = true
          this.totaldataForm = true
        } else {
          this.totaldata = false
          this.totaldataForm = false
          this.totaldataNoForm = true
        }
        loader.hide()
      })
    },
    loadFacultyCase () {
      let loader = this.$loading.show()

      var ListCase = IberoHelpers.getCasedataFaculty(
        this.$store,
        this.$route.params.idCase,
        this.$session.get('IberoJWTAdminLogin').idPerson
      )
      debugger

      ListCase.then((Response) => {
        var numCases = 0
        var limitCase = 0
        this.modelArray = {}
        this.programArray = {}
        this.tempData = {}
        this.CaseRef = Response.data.Case[0]
        this.tempData.idCelular = 2
        this.tempData.detCelular = ''
        this.tempData.idMail = 3
        this.tempData.detMail = ''

        debugger

        if (this.CaseRef.CaseIbero !== undefined) {
          this.titleCase =
            'Crear Caso - ' + this.CaseRef.CaseIbero[0].CaseDetail
        } else {
          this.titleCase = 'Crear Caso'
        }

        // this.titleCase = 'prueba 12345';

        if (this.CaseRef.ContactInformation !== undefined) {
          this.tempData.detCelular = this.dataFindUser(
            this.CaseRef.ContactInformation,
            2
          )
          this.formUpdModel.RefCelPhone = this.tempData.detCelular
          this.tempData.detMail = this.dataFindUser(
            this.CaseRef.ContactInformation,
            3
          )
          this.formUpdModel.RefMail = this.tempData.detMail
        }

        if (this.CaseRef.FacultyProgram !== undefined) {
          this.tempData.FacultyID = this.CaseRef.FacultyProgram[0].FacultyID
          this.tempData.FacultyName =
            this.CaseRef.FacultyProgram[0].FacultyName
          this.tempData.ProgramId = this.CaseRef.FacultyProgram[0].ProgramId
          this.tempData.ProgramName =
            this.CaseRef.FacultyProgram[0].ProgramName

          this.DLDataList = this.CaseRef.CasePerson

          debugger

          if (this.CaseRef.CaseIbero !== undefined) {
            limitCase = this.CaseRef.CaseIbero[0].CaseNumLimit
          } else {
            this.refNoCase = true
          }

          if (this.DLDataList !== undefined) {
            numCases = this.DLDataList.length
          }

          if (!(numCases >= limitCase)) {
            this.tempData.CaseDetail = this.CaseRef.CaseIbero[0].CaseDetail
            this.tempData.CaseTypeName = this.CaseRef.CaseIbero[0].CaseTypeName
            this.tempData.CaseCourses = this.CaseRef.CaseIbero[0].CaseCourses
            this.tempData.CaseReason = this.CaseRef.CaseIbero[0].CaseReason
            this.tempData.CaseId = this.CaseRef.CaseIbero[0].CaseId
            this.tempData.CaseDetail = this.CaseRef.CaseIbero[0].CaseDetail
            this.tempData.CaseNote = this.CaseRef.CaseIbero[0].CaseNote
            debugger

            if (this.CaseRef.CaseIbero[0].CaseCourses !== undefined) {
              debugger

              for (var i = 0; i < this.CaseRef.CaseIbero[0].CaseCourses.length; i++) {
                this.modelArray[this.CaseRef.CaseIbero[0].CaseCourses[i].CaseIDByCourse] = false
                this.courseArray[this.CaseRef.CaseIbero[0].CaseCourses[i].CaseIDByCourse] = this.CaseRef.CaseIbero[0].CaseCourses[i].CaseCourseName
              }

              this.totaldata = true
              this.totaldataFacul = true
              this.totaldataForm = false
            } else {
              debugger
              this.refNoProgram = true
            }
          } else if (limitCase >= 1) {
            this.refdataResum = true
            this.totaldataResum = true
          }

          if (numCases >= 1) {
            this.totaldataResum = true
          }
        } else {
          debugger
          this.noStudent = true
        }

        loader.hide()
      })
    },
  },
  created: function () {
    if (this.$route.params.idCase === '1') {
      this.loadFacultyCase()
    } else {
      this.loadCaseForm()
    }
  },
}
</script>